<template>
    <div id="info-box" v-bind:class="{'disable': !opened}">
        <div class="bar" v-on:mouseover="opened = !opened">
            <div class="arrow">
                <span v-if="opened"> > </span>
                <span v-else> < </span>
            </div>
            <!--<div class="text">-->
                <!--<div style="transform:rotate(-90deg); -webkit-transform:rotate(-90deg);-moz-transform:rotate(-90deg); -o-transform:rotate(-90deg);">-->
                    <!--Informacje o panelu-->
                <!--</div>-->
            <!--</div>-->
        </div>
        <div class="content">

            <div class="title">{{title}}</div>
            <div class="body">
                <div v-html="body"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        data: function() {
            return {
                opened: false
            };
        },
        methods: {
        }
    }
</script>

<style lang="sass">
    #info-box {
        width:340px;
        height:100%;
        position:absolute;
        z-index:0;
        background-color:white;
        right:0;
        bottom:0;
        border-left: 1px solid black;

        &.disable {
            width:45px;

            .content {
                display:none;
            }
        }

        .bar{
            float:left;
            width: 40px;
            position:absolute;
            height:100%;
            background-color:black;
            color:white;
            text-align:center;

            .arrow {
                margin-top:15px;
                font-size:25px;
            }

            .text{
                /*height:100px;*/
            }
        }

        .content {
            float:left;
            padding-left:40px;
            position:static;
            height:100%;
        }

        .title {
            margin-top:15px;
            background-color:#F9F9F9;
            text-align:center;
            padding:10px;
        }

        .body {
            padding:15px;
            text-align:justify;
        }
    }
</style>


// WEBPACK FOOTER //
// DataTableInfoBox.vue?9ff2c7b2